<template>
  <!-- 视频列表页 -->
  <div style="overflow: hidden; margin-top: 0.7rem">
    <div style="width: 12.8rem; margin: 0.3rem auto 0">
      <!-- 头部 -->
      <div class="body_main">
        <div class="body_main_ss">
          <div class="body_main_ss_left">
            <div class="select">
              <div
                style="
                  display: flex;
                  font-size: 0.14rem;
                  padding: 0.16rem;
                  cursor: pointer;
                "
              >
                <div>
                  {{
                    top_type == "MUSIC"
                      ? "音乐"
                      : top_type == "VIDEO"
                      ? "视频"
                      : top_type == "IMAGE"
                      ? "图片"
                      : ""
                  }}
                </div>
                <div class="select_icon select_icon_"></div>
              </div>
              <div class="select_box_">
                <div class="select_box">
                  <div @click="allWorksClick('VIDEO')" class="select_box_slect">
                    视频
                  </div>
                  <div @click="allWorksClick('MUSIC')" class="select_box_slect">
                    音乐
                  </div>
                  <div @click="allWorksClick('IMAGE')" class="select_box_slect">
                    图片
                  </div>
                </div>
              </div>
            </div>
            <div class="line">
              <!-- 分割线 -->
            </div>
            <input
              v-model="keyword"
              :placeholder="
                top_type == 'MUSIC'
                  ? '输入关键字搜索'
                  : top_type == 'VIDEO'
                  ? '输入关键字搜索'
                  : top_type == 'IMAGE'
                  ? '输入关键字搜索'
                  : ''
              "
              @keyup.enter="checked_ss"
            />
          </div>
          <button class="body_main_ss_right" @click="checked_ss">
            <img src="../../assets/yxsc_ss.png" />
            搜索
          </button>
        </div>
        <div v-if="top_type == 'VIDEO'">
          <videoAll
            :keyword="keyword"
            :route_query="route_query"
            style="margin-top: 0.2rem"
            v-if="top_type == 'VIDEO'"
          >
          </videoAll>
        </div>
        <div v-if="top_type == 'MUSIC'">
          <musicAll
            :keyword="keyword"
            :route_query="route_query"
            style="margin-top: 0.2rem"
            v-if="top_type == 'MUSIC'"
          >
          </musicAll>
        </div>
        <div v-if="top_type == 'IMAGE'">
          <imageAll
            :keyword="keyword"
            :route_query="route_query"
            style="margin-top: 0.2rem"
            v-if="top_type == 'IMAGE'"
          >
          </imageAll>
        </div>

        <div style="height: 30px">
          <!-- 留点距离 -->
        </div>
      </div>
      <!-- <div v-if="top_type =='VIDEO'">
				<videoAll :route_query="route_query" style="margin-top: 0.2rem;" v-if="top_type == 'VIDEO'"></videoAll>
			</div>
			<div v-if="top_type =='MUSIC'">
				<imageAll  style="margin-top: 0.2rem;" v-if="top_type == 'IMAGE'"></imageAll>
					
			</div>
			<div v-if="top_type =='IMAGE'">
				<imageAll  style="margin-top: 0.2rem;" v-if="top_type == 'IMAGE'"></imageAll>
			</div> -->
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";

import dropDown from "../../components/comTemplate/drop-down.vue";
import imageAll from "./template/imageAll";
import videoAll from "./template/videoAll";
import musicAll from "./template/musicAll.vue";
const router = useRouter();

const value = ref("1");
const options = [
  {
    value: "1",
    label: "视频",
  },

  {
    value: "2",
    label: "音乐",
  },
  {
    value: "3",
    label: "图片",
  },
];
// const goParticulars = function() {
// 	router.push({
// 		path: '/ShadowMaterialVideoParticulars',
// 	})
// }
// const valueSelect = ref(['实拍视频', 'AE模板', '背景视频', '视频元素', '价格', '时长', '分辨率', '宽高比', '默认排序'])

const route = useRoute();
const top_type = ref(route.query.materialType);
const route_query = ref(route.query);
watch(
  () => route.query.materialType,
  (newData, oldData) => {
    top_type.value = newData;
  }
);
const keyword = ref("");
let inputTitle = "";

router.currentRoute.value.query
  ? router.currentRoute.value.query.hasOwnProperty("inputTitle")
    ? (inputTitle = router.currentRoute.value.query.inputTitle)
    : ""
  : "";

router.currentRoute.value.query
  ? router.currentRoute.value.query.hasOwnProperty("keyword")
    ? (keyword.value = router.currentRoute.value.query.keyword)
    : ""
  : "";

keyword.value = inputTitle || "";
const checked_ss = function () {
  router.push({
    path: "/ShadowMaterialVideoList",
    query: {
      materialType: top_type.value,
      keyword: keyword.value,
    },
  });
};
// 音频/视频/图片跳转
const allWorksClick = function (type) {
  router.push({
    path: "/ShadowMaterialVideoList",
    query: {
      materialType: type,
    },
  });
  // setTimeout(() => {
  // 	// 在组件加载后自动刷新页面
  // 	  window.location.reload();
  // },200)
};
</script>

<style scoped lang="less">
.SL_offerMaterialListdiv {
  transition: all 0.5s;
  width: 3.02rem;
  height: 1.7rem;
  position: relative;
  margin-bottom: 0.3rem;
  display: block;
  overflow: hidden;
}

.body_main {
  width: 12.8rem;
  margin: 0 auto;
  position: relative;
}

.SL_hotSongwriter {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 0.7rem;
  margin-bottom: 0.3rem;
}

.SL_hotSongwriter_title {
  font-size: 0.24rem;
  color: #000;
}

.SL_hotSongwriter_click {
  font-size: 0.14rem;
  color: #333;
}

.body_main_ss {
  display: flex;
  border-radius: 0.08rem;
  overflow: hidden;
  margin-bottom: 0.03rem;
}

.body_main_ss_right {
  width: 1rem;
  background: #C01A26;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 0.14rem;
  border: 0rem solid #fff;
  padding: 0.16rem 0;
}

.body_main_ss_left {
  flex-grow: 1;
  display: flex;
  background: #f2f3f5;

  .line {
    width: 1px;
    height: 0.2rem;
    background: #86909c;
    position: absolute;
    left: 0.75rem;
    top: 0.14rem;
  }

  .select_icon {
    margin-left: 0.04rem;
    width: 0.14rem;
    height: 0.14rem;
    margin-top: 0.04rem;
    background: url(data:image/png;base64,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);
    background-size: 100% 100%;
  }

  .select_box {
    position: absolute;
    // margin-top: 0.18rem;
    text-align: center;
    min-width: 0.8rem;
    z-index: 15;
    border-radius: 0.08rem;
    background: #fff;
    padding: 0.04rem;
    box-sizing: border-box;
    display: none;
    box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(32, 40, 58, 0.25);

    .select_box_slect:hover,
    .selectboxTrue {
      background: #f0f1f1;
      color: #333333;
      cursor: pointer;
    }

    .select_box_slect {
      line-height: 0.37rem;
      padding: 0 0.08rem !important;
      box-sizing: border-box;
    }
  }
}

.body_main_ss_left .select:hover {
  .select_box {
    display: block;
  }
}

.body_main_ss_left > div {
  align-items: center;
  width: 0.9rem;
}

.body_main_ss_left > input {
  flex-grow: 1;
  border: 0rem solid #fff;
  background: #f2f3f5;
  /* border-left:0.01rem solid #333; */
}

.body_main_ss_right > img {
  width: 0.16rem;
  height: 0.16rem;
}

.selectList {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.04rem;
  color: #000000;
  font-size: 0.14rem;
  width: 100%;
}

/deep/.el-input__wrapper {
  width: 1rem;
  box-shadow: auto;
}

/deep/.el-input__wrapper:hover {
  box-shadow: auto;
}

// 下拉2
::v-deep.no-border ::selection {
  background-color: transparent;
  color: inherit;
}

// 分页
/deep/.el-input__wrapper,
.el-input,
.el-input--suffix {
  width: 0.74rem;
  background: #f2f3f5;
}

/deep/ .el-input,
.el-input--suffix {
  border: 0rem solid #fff;
}

/deep/.el-pager li {
  padding: 0.06rem;
  margin: 0 0.03rem;
}

/deep/.el-pager li.is-active {
  color: #fff;
  background: #C01A26;
}

/deep/.el-pager li:hover {
  color: #fff;
  background: #C01A26;
}

.el-pagination {
  justify-content: center;
  margin: 0.4rem 0;
}
</style>
